import NextLazyImage from "@/components/Core/NextLazyImage";
import CtaRenderer from "@/components/Shared/CtaRenderer";
import IconRenderer from "@/components/Shared/IconRenderer";
import mq from "@/utils/mq";
import styled, { css } from "styled-components";

const BentoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 0 0 66%;
  background-color: #141516;
  border-radius: 16px;
  ${mq.mobile(css`
    height: 100%;
  `)};
`;

const LargeBentoOuter = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  height: 100%;
  ${mq.mobile(css`
    flex-direction: column;
  `)};
`;

const ImageContainer = styled.div`
  height: 100%;
  width: auto;
  aspect-ratio: 3/4;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  padding: 8px;
  ${mq.mobile(css`
    aspect-ratio: 16/9;
    height: auto;
    width: 100%;
    img {
      width: 100%;
    }
  `)};
`;

const BentoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  justify-content: space-between;
  padding: 22px;
`;

const BentoSubtitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const Subtitle = styled.div`
  color: #7c7c7c;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.div`
  color: #fff;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
`;

export default function LargeBentoGridItem({ item }: { item: any }) {
  return <BentoContainer>{item?.component === "largeBento" && <LargeBento item={item} />}</BentoContainer>;
}

const LargeBento = ({ item }: { item: any }) => {
  return (
    <LargeBentoOuter>
      <ImageContainer>
        <NextLazyImage src={item?.asset?.filename} alt={item?.asset?.alt} fill style={{ borderRadius: "8px" }} />
      </ImageContainer>
      <BentoContent>
        <BentoSubtitle>
          <IconRenderer icon={item?.subtitleIcon} color='#7c7c7c' />
          <Subtitle>{item?.subtitle}</Subtitle>
        </BentoSubtitle>
        <TitleContainer>
          <Title>{item?.title}</Title>
          <CtaRenderer ctas={item?.ctas} darkMode />
        </TitleContainer>
      </BentoContent>
    </LargeBentoOuter>
  );
};
